(function () {
  'use strict';

  var FOCUSABLE_SELECTORS =
    'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function trapFocus(container, event) {
    var focusables = container.querySelectorAll(FOCUSABLE_SELECTORS);
    if (focusables.length === 0) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function PdVideoModal(modal) {
    this.modal = modal;
    this.previousFocus = null;
    this.video = modal.querySelector('video, iframe');
    this.openTrigger = null;

    this.close = this.close.bind(this);
    this.onKey = this.onKey.bind(this);

    modal.querySelectorAll('[data-pd-modal-close]').forEach(
      function (el) {
        el.addEventListener('click', this.close);
      }.bind(this)
    );
  }

  PdVideoModal.prototype.open = function (trigger) {
    this.previousFocus = trigger || document.activeElement;
    this.openTrigger = trigger;

    if (this.modal.parentElement !== document.body) {
      document.body.appendChild(this.modal);
    }

    this.modal.removeAttribute('hidden');
    document.body.classList.add('pd-modal-open');
    document.addEventListener('keydown', this.onKey);

    var firstFocus = this.modal.querySelector('.pd__modal-close');
    if (firstFocus) {
      firstFocus.focus();
    }

    if (this.video && typeof this.video.play === 'function') {
      try {
        this.video.play();
      } catch (e) {
        /* autoplay blocked is fine, user can press play */
      }
    }

    // Auto-load a deferred 3D model so it's interactive as soon as the modal
    // opens (no extra tap on the poster).
    var deferredModel = this.modal.querySelector('product-model');
    if (
      deferredModel &&
      !deferredModel.getAttribute('loaded') &&
      typeof deferredModel.loadContent === 'function'
    ) {
      try {
        deferredModel.loadContent(false);
      } catch (e) {
        /* poster click fallback remains available */
      }
    }
  };

  PdVideoModal.prototype.close = function () {
    this.modal.setAttribute('hidden', '');
    document.body.classList.remove('pd-modal-open');
    document.removeEventListener('keydown', this.onKey);

    if (this.video && typeof this.video.pause === 'function') {
      try {
        this.video.pause();
        if ('currentTime' in this.video) this.video.currentTime = 0;
      } catch (e) {
        /* not a media element */
      }
    }

    if (this.previousFocus && typeof this.previousFocus.focus === 'function') {
      this.previousFocus.focus();
    }
    this.previousFocus = null;
    this.openTrigger = null;
  };

  PdVideoModal.prototype.onKey = function (event) {
    if (event.key === 'Escape') {
      event.stopPropagation();
      this.close();
      return;
    }
    if (event.key === 'Tab') {
      trapFocus(this.modal, event);
    }
  };

  function initVideoModals(scope) {
    var root = scope || document;
    root.querySelectorAll('.pd__modal').forEach(function (modalEl) {
      if (modalEl.parentElement !== document.body) {
        var existing = document.getElementById(modalEl.id);
        if (existing && existing !== modalEl && existing.parentElement === document.body) {
          existing.parentElement.removeChild(existing);
        }
        document.body.appendChild(modalEl);
      }
      if (modalEl.__pdModal) return;
      modalEl.__pdModal = new PdVideoModal(modalEl);
    });

    document.querySelectorAll('[data-pd-modal-open]').forEach(function (trigger) {
      if (trigger.__pdBound) return;
      trigger.__pdBound = true;
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        var targetId = trigger.getAttribute('data-pd-modal-open');
        var target = document.getElementById(targetId);
        if (target && target.__pdModal) {
          target.__pdModal.open(trigger);
        }
      });
    });
  }

  var PD_ACCORDION_DURATION_MS = 420;
  var PD_ACCORDION_EASING = 'cubic-bezier(0.33, 1, 0.68, 1)';

  function bindPdAccordion(details, accordionSection) {
    if (details.__pdAccordionBound) return;
    var summary = details.querySelector('summary');
    var panel = details.querySelector('.pd__accordion-panel');
    var animEl = panel || details.querySelector('.pd__accordion-content');
    if (!summary || !animEl) return;

    var reducedMotion =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var transition =
      'max-height ' + PD_ACCORDION_DURATION_MS / 1000 + 's ' + PD_ACCORDION_EASING;

    function clearAnimStyles() {
      animEl.style.maxHeight = '';
      animEl.style.overflow = '';
      animEl.style.transition = '';
    }

    function closeAccordion(skipAnimation) {
      if (skipAnimation) {
        details.__pdAccordionAnimating = false;
        details.classList.remove('pd__accordion--closing');
        details.classList.remove('pd__accordion--opening');
        clearAnimStyles();
        details.removeAttribute('open');
        return;
      }

      if (!details.hasAttribute('open') || details.__pdAccordionAnimating) return;

      if (reducedMotion) {
        details.removeAttribute('open');
        return;
      }

      var safetyTimer;
      function doneAnimating() {
        details.__pdAccordionAnimating = false;
        if (safetyTimer) {
          window.clearTimeout(safetyTimer);
          safetyTimer = null;
        }
      }

      details.__pdAccordionAnimating = true;
      details.classList.add('pd__accordion--closing');
      var closeStart = animEl.scrollHeight;
      animEl.style.overflow = 'hidden';
      animEl.style.maxHeight = closeStart + 'px';
      void animEl.offsetHeight;
      animEl.style.transition = transition;
      animEl.style.maxHeight = '0px';

      function onEndClose(e) {
        if (e.target !== animEl || e.propertyName !== 'max-height') return;
        animEl.removeEventListener('transitionend', onEndClose);
        details.classList.remove('pd__accordion--closing');
        details.removeAttribute('open');
        clearAnimStyles();
        doneAnimating();
      }

      animEl.addEventListener('transitionend', onEndClose);
      safetyTimer = window.setTimeout(function () {
        animEl.removeEventListener('transitionend', onEndClose);
        details.classList.remove('pd__accordion--closing');
        details.removeAttribute('open');
        clearAnimStyles();
        doneAnimating();
      }, PD_ACCORDION_DURATION_MS + 100);
    }

    function openAccordion() {
      if (details.hasAttribute('open') || details.__pdAccordionAnimating) return;

      details.setAttribute('open', '');
      if (reducedMotion) return;

      var safetyTimer;
      function doneAnimating() {
        details.__pdAccordionAnimating = false;
        if (safetyTimer) {
          window.clearTimeout(safetyTimer);
          safetyTimer = null;
        }
      }

      details.__pdAccordionAnimating = true;
      details.classList.add('pd__accordion--opening');
      animEl.style.overflow = 'hidden';
      animEl.style.maxHeight = '0px';
      void animEl.offsetHeight;
      var openTarget = animEl.scrollHeight;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          details.classList.remove('pd__accordion--opening');
          animEl.style.transition = transition;
          animEl.style.maxHeight = openTarget + 'px';
        });
      });

      function onEndOpen(e) {
        if (e.target !== animEl || e.propertyName !== 'max-height') return;
        animEl.removeEventListener('transitionend', onEndOpen);
        animEl.style.maxHeight = 'none';
        clearAnimStyles();
        doneAnimating();
      }

      animEl.addEventListener('transitionend', onEndOpen);
      safetyTimer = window.setTimeout(function () {
        animEl.removeEventListener('transitionend', onEndOpen);
        animEl.style.maxHeight = 'none';
        clearAnimStyles();
        doneAnimating();
      }, PD_ACCORDION_DURATION_MS + 100);
    }

    details.__pdAccordionApi = {
      open: openAccordion,
      close: closeAccordion
    };

    summary.addEventListener('click', function (event) {
      event.preventDefault();

      if (details.__pdAccordionAnimating) return;

      if (details.hasAttribute('open')) {
        closeAccordion(false);
        return;
      }

      if (accordionSection && accordionSection.singleOpen) {
        accordionSection.closeOthers(details);
      }
      openAccordion();
    });

    details.__pdAccordionBound = true;
  }

  function PdAccordionSection(section) {
    this.section = section;
    this.singleOpen = section.getAttribute('data-pd-accordion-single-open') === 'true';
    this.items = Array.from(section.querySelectorAll('[data-pd-accordion]'));
    this.items.forEach(
      function (item) {
        bindPdAccordion(item, this);
      }.bind(this)
    );
    this.normalizeOpenState();
  }

  PdAccordionSection.prototype.closeOthers = function (activeItem) {
    this.items.forEach(function (item) {
      if (item === activeItem || !item.hasAttribute('open')) return;
      if (item.__pdAccordionApi && typeof item.__pdAccordionApi.close === 'function') {
        item.__pdAccordionApi.close(true);
      } else {
        item.removeAttribute('open');
      }
    });
  };

  PdAccordionSection.prototype.normalizeOpenState = function () {
    if (!this.singleOpen) return;
    var firstOpen = null;
    this.items.forEach(function (item) {
      if (!item.hasAttribute('open')) return;
      if (!firstOpen) {
        firstOpen = item;
        return;
      }
      if (item.__pdAccordionApi && typeof item.__pdAccordionApi.close === 'function') {
        item.__pdAccordionApi.close(true);
      } else {
        item.removeAttribute('open');
      }
    });
  };

  function initAccordions(scope) {
    var root = scope || document;
    root.querySelectorAll('.pd').forEach(function (section) {
      if (section.__pdAccordionsInit) return;
      section.__pdAccordionsInit = true;
      new PdAccordionSection(section);
    });
  }

  function getPswpGalleryRoot(section) {
    var desktop = section.querySelector('.pd__gallery--desktop');
    if (desktop && typeof window.matchMedia === 'function' && window.matchMedia('(min-width: 990px)').matches) {
      return desktop;
    }
    return section.querySelector('.pd__gallery--mobile');
  }

  function setupLightboxForSection(section) {
    if (!section.querySelector('.pd__zoom-trigger')) return;

    function getActiveImages() {
      var root = getPswpGalleryRoot(section);
      if (!root) return [];
      return Array.prototype.slice
        .call(root.querySelectorAll('.pd__gallery-item--image'))
        .filter(function (el) {
          return el.querySelector('.pd__zoom-trigger');
        });
    }

    function buildItems(activeImages) {
      return activeImages
        .map(function (item) {
          var a = item.querySelector('.pd__zoom-trigger');
          if (!a) return null;
          return {
            src: a.getAttribute('href'),
            msrc: a.dataset.msrc,
            w: parseInt(a.dataset.w, 10) || 1200,
            h: parseInt(a.dataset.h, 10) || 1200,
            title: a.getAttribute('title') || ''
          };
        })
        .filter(Boolean);
    }

    function openPswp(link) {
      var pswpElement = document.querySelector('.pswp');
      if (!pswpElement) return;
      if (typeof window.PhotoSwipe === 'undefined' || typeof window.PhotoSwipeUI_Default === 'undefined') {
        // Vendor scripts haven't loaded yet — let the anchor's
        // target="_blank" fallback handle the click.
        return false;
      }

      var activeImages = getActiveImages();
      var items = buildItems(activeImages);
      var parent = link.closest('.pd__gallery-item');
      var i = activeImages.indexOf(parent);

      var multiImage = items.length > 1;
      var options = {
        index: i >= 0 ? i : 0,
        maxSpreadZoom: 2,
        spacing: 0,
        loop: false,
        allowPanToNext: multiImage,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: multiImage,
        history: false,
        captionEl: true,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: multiImage,
        arrowEl: multiImage,
        preloaderEl: true,
        getThumbBoundsFn: function () {
          var thumbnail = link.closest('.pd__gallery-main-stage') || link.closest('.pd__gallery-item');
          var pageYScroll = window.scrollY || document.documentElement.scrollTop;
          var rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      };

      try {
        pswpElement.classList.toggle('pswp--single-image', !multiImage);
        var pswp = new window.PhotoSwipe(pswpElement, window.PhotoSwipeUI_Default, items, options);
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = { top: 50, bottom: 50 };
          });
        });
        pswp.listen('destroy', function () {
          pswpElement.classList.remove('pswp--single-image');
        });
        pswp.init();
        return true;
      } catch (err) {
        return false;
      }
    }

    section.querySelectorAll('.pd__zoom-trigger').forEach(function (link) {
      if (link.__pdZoomBound) return;
      link.__pdZoomBound = true;
      link.addEventListener('click', function (event) {
        var opened = openPswp(link);
        if (opened !== false) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    });

    var galleryRoots = [];
    var mobileRoot = section.querySelector('.pd__gallery--mobile');
    var desktopRoot = section.querySelector('.pd__gallery--desktop');
    if (mobileRoot) galleryRoots.push(mobileRoot);
    if (desktopRoot) galleryRoots.push(desktopRoot);

    galleryRoots.forEach(function (galleryRoot) {
      galleryRoot.querySelectorAll('.pd__gallery-item--image').forEach(function (figure) {
        if (figure.__pdImageBound) return;
        var link = figure.querySelector('.pd__zoom-trigger');
        if (!link) return;
        figure.__pdImageBound = true;
        figure.addEventListener('click', function (event) {
          if (event.target.closest('.pd__zoom-trigger')) return;
          if (event.target.closest('.pd__image-modal-trigger')) return;
          var opened = openPswp(link);
          if (opened !== false) {
            event.preventDefault();
          }
        });
      });
    });
  }

  function pauseVideosIn(el) {
    if (!el) return;
    el.querySelectorAll('video').forEach(function (v) {
      try {
        v.pause();
      } catch (e) {
        /* ignore */
      }
    });
  }

  function playGallerySlideVideos(slide) {
    if (!slide) return;
    slide.querySelectorAll('video').forEach(function (v) {
      if (!v.closest('.pd__gallery-item--video')) return;
      try {
        v.muted = true;
        var p = v.play();
        if (p && typeof p.then === 'function') {
          p.catch(function () {
            /* autoplay blocked until user gesture — acceptable */
          });
        }
      } catch (e) {
        /* ignore */
      }
    });
  }

  function setDesktopGallerySlide(desktop, index) {
    var slides = desktop.querySelectorAll('[data-pd-gallery-main] .pd__gallery-slide');
    var thumbs = desktop.querySelectorAll('[data-pd-slide-to]');
    var activated = null;
    slides.forEach(function (slide) {
      var si = parseInt(slide.getAttribute('data-pd-slide'), 10);
      if (si === index) {
        slide.classList.add('is-active');
        slide.removeAttribute('hidden');
        activated = slide;
      } else {
        slide.classList.remove('is-active');
        slide.setAttribute('hidden', '');
        pauseVideosIn(slide);
      }
    });
    if (activated) {
      requestAnimationFrame(function () {
        playGallerySlideVideos(activated);
      });
    }
    thumbs.forEach(function (thumb) {
      var n = parseInt(thumb.getAttribute('data-pd-slide-to'), 10);
      if (n === index) {
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-current', 'true');
      } else {
        thumb.classList.remove('is-active');
        thumb.setAttribute('aria-current', 'false');
      }
    });
  }

  function initPdGalleryDesktop(section) {
    var desktop = section.querySelector('[data-pd-gallery-desktop]');
    if (!desktop || !desktop.querySelector('[data-pd-slide-to]')) return;
    if (desktop.__pdGalleryBound) return;
    desktop.__pdGalleryBound = true;

    var thumbsHost = desktop.querySelector('[data-pd-gallery-thumbs]');
    var scrollEl = desktop.querySelector('[data-pd-thumbs-scroll]');
    if (!thumbsHost || !scrollEl) return;

    function thumbAxisOffset(thumb, horizontal) {
      if (horizontal) {
        return scrollEl.scrollLeft + (thumb.getBoundingClientRect().left - scrollEl.getBoundingClientRect().left);
      }
      return scrollEl.scrollTop + (thumb.getBoundingClientRect().top - scrollEl.getBoundingClientRect().top);
    }

    function scrollThumbIntoViewStart(thumb, horizontal) {
      var target = thumbAxisOffset(thumb, horizontal);
      if (horizontal) {
        var maxL = scrollEl.scrollWidth - scrollEl.clientWidth;
        scrollEl.scrollTo({ left: Math.max(0, Math.min(maxL, target)), behavior: 'smooth' });
      } else {
        var maxT = scrollEl.scrollHeight - scrollEl.clientHeight;
        scrollEl.scrollTo({ top: Math.max(0, Math.min(maxT, target)), behavior: 'smooth' });
      }
    }

    function scrollThumbRailByArrow(direction, horizontal) {
      var thumbs = scrollEl.querySelectorAll('.pd__gallery-thumb');
      if (!thumbs.length) return;

      var pos = horizontal ? scrollEl.scrollLeft : scrollEl.scrollTop;
      var maxScroll = horizontal
        ? scrollEl.scrollWidth - scrollEl.clientWidth
        : scrollEl.scrollHeight - scrollEl.clientHeight;

      var offsets = Array.prototype.map.call(thumbs, function (t) {
        return thumbAxisOffset(t, horizontal);
      });

      var target;
      if (direction === 'prev') {
        var j = -1;
        for (var i = offsets.length - 1; i >= 0; i--) {
          if (offsets[i] < pos - 2) {
            j = i;
            break;
          }
        }
        target = j >= 0 ? offsets[j] : 0;
      } else {
        var jn = -1;
        for (var k = 0; k < offsets.length; k++) {
          if (offsets[k] > pos + 2) {
            jn = k;
            break;
          }
        }
        if (jn < 0) return;
        target = offsets[jn];
      }

      target = Math.max(0, Math.min(maxScroll, target));
      if (horizontal) {
        scrollEl.scrollTo({ left: target, behavior: 'smooth' });
      } else {
        scrollEl.scrollTo({ top: target, behavior: 'smooth' });
      }
    }

    thumbsHost.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-pd-slide-to]');
      if (!btn || !thumbsHost.contains(btn)) return;
      var idx = parseInt(btn.getAttribute('data-pd-slide-to'), 10);
      if (isNaN(idx)) return;
      setDesktopGallerySlide(desktop, idx);
      var isBottom = thumbsHost.classList.contains('pd__gallery-thumbs--bottom');
      scrollThumbIntoViewStart(btn, isBottom);
    });

    function thumbRailHasOverflow() {
      var horizontal = thumbsHost.classList.contains('pd__gallery-thumbs--bottom');
      return horizontal
        ? scrollEl.scrollWidth > scrollEl.clientWidth + 2
        : scrollEl.scrollHeight > scrollEl.clientHeight + 2;
    }

    function updateThumbArrowsVisibility() {
      var showArrows = thumbRailHasOverflow();
      thumbsHost.classList.toggle('pd__gallery-thumbs--no-scroll', !showArrows);
      thumbsHost.querySelectorAll('[data-pd-gallery-scroll]').forEach(function (arrow) {
        if (showArrows) {
          arrow.removeAttribute('hidden');
          arrow.removeAttribute('aria-hidden');
        } else {
          arrow.setAttribute('hidden', '');
          arrow.setAttribute('aria-hidden', 'true');
        }
      });
    }

    thumbsHost.querySelectorAll('[data-pd-gallery-scroll]').forEach(function (arrow) {
      arrow.addEventListener('click', function () {
        if (arrow.hasAttribute('hidden')) return;
        var dir = arrow.getAttribute('data-pd-gallery-scroll');
        var isBottom = thumbsHost.classList.contains('pd__gallery-thumbs--bottom');
        scrollThumbRailByArrow(dir, isBottom);
      });
    });

    updateThumbArrowsVisibility();
    requestAnimationFrame(updateThumbArrowsVisibility);

    scrollEl.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', updateThumbArrowsVisibility);
    });

    if (typeof ResizeObserver !== 'undefined') {
      var thumbResizeObserver = new ResizeObserver(updateThumbArrowsVisibility);
      thumbResizeObserver.observe(scrollEl);
    }
    window.addEventListener('resize', updateThumbArrowsVisibility);
  }

  function initLightbox(scope) {
    var root = scope || document;
    root.querySelectorAll('.pd').forEach(function (section) {
      setupLightboxForSection(section);
    });
  }

  function initAll(scope) {
    initVideoModals(scope);
    initAccordions(scope);
    initLightbox(scope);
    var root = scope || document;
    root.querySelectorAll('.pd').forEach(function (section) {
      initPdGalleryDesktop(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) initAll(event.target);
  });
})();
